import PSD from "psd.js";
import { baseUrl } from "../../../config";

export default {
  props: {
    file: Object,
  },
  data() {
    return {
      overwriteImg: false,
    };
  },
  created() {
    this.setPsdPreview();
  },
  methods: {
    createDownloadLink() {
      let downloadLink = `${baseUrl}/download?file=${this.file.id}`;

      downloadLink += `&company=${this.$store.state.company}`;
      downloadLink += `&myspace=${this.mySpace}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },
    setPsdPreview() {
      this.overwriteImg = false;

      if (this.file.extension) {
        if (this.file.extension.toLowerCase().replace(".", "") === "psd") {
          PSD.fromURL(this.createDownloadLink()).then((psd) => {
            if (psd.image.toPng().src) {
              this.overwriteImg = psd.image.toPng().src;
            }
          });
        }
      }
    },
  },
};
